export enum DocumentAlertSetupPageType {
    PatientOrder = 1,
    PhysicianOrder = 2,
    LabOrderManagement = 3,
}
